import clamp from "lodash/clamp";

import type { PanelSize } from "../floating_position_store/floating_position_store";
import type { ResizeDirection } from "../parts/get_resize_direction";

export type ResizeDelta = {
  newWidth: number;
  newHeight: number;
  newLeft: number | null;
  newTop: number | null;
};

export type ViewportBounds = {
  minLeft: number;
  maxRight: number;
  minTop: number;
  maxBottom: number;
};

export const computeResizeDelta = (
  direction: ResizeDirection,
  dx: number,
  dy: number,
  startWidth: number,
  startHeight: number,
  startTop: number,
  startLeft: number,
  minSize: PanelSize,
  maxSize: PanelSize,
  viewportBounds?: ViewportBounds
): ResizeDelta => {
  let newWidth = startWidth;
  let newHeight = startHeight;
  let newLeft: number | null = null;
  let newTop: number | null = null;

  if (direction.includes("e")) {
    newWidth = clamp(startWidth + dx, minSize.width, maxSize.width);
    if (viewportBounds) {
      newWidth = clamp(Math.min(newWidth, viewportBounds.maxRight - startLeft), minSize.width, maxSize.width);
    }
  }
  if (direction.includes("w")) {
    const clamped = clamp(startWidth - dx, minSize.width, maxSize.width);
    newLeft = startLeft + (startWidth - clamped);
    newWidth = clamped;
    if (viewportBounds) {
      newLeft = Math.max(newLeft, viewportBounds.minLeft);
      newWidth = clamp(startLeft + startWidth - newLeft, minSize.width, maxSize.width);
    }
  }
  if (direction.includes("s")) {
    newHeight = clamp(startHeight + dy, minSize.height, maxSize.height);
    if (viewportBounds) {
      newHeight = clamp(
        Math.min(newHeight, viewportBounds.maxBottom - startTop),
        minSize.height,
        maxSize.height
      );
    }
  }
  if (direction.includes("n")) {
    const clamped = clamp(startHeight - dy, minSize.height, maxSize.height);
    newTop = startTop + (startHeight - clamped);
    newHeight = clamped;
    if (viewportBounds) {
      newTop = Math.max(newTop, viewportBounds.minTop);
      newHeight = clamp(startTop + startHeight - newTop, minSize.height, maxSize.height);
    }
  }

  return { newWidth, newHeight, newLeft, newTop };
};
